import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React from 'react';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import RenderLoading from './render-loading';
var defaultStyles = StyleSheet({
  listContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    transform: 'translate3d(0, 0, 0)'
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '60vh'
  }
});
var RenderLoadingList = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RenderLoadingList, _React$PureComponent);

  function RenderLoadingList() {
    _classCallCheck(this, RenderLoadingList);

    return _possibleConstructorReturn(this, _getPrototypeOf(RenderLoadingList).apply(this, arguments));
  }

  _createClass(RenderLoadingList, [{
    key: "getListLoadingOrError",
    value: function getListLoadingOrError() {
      var _this$props = this.props,
          isListLoading = _this$props.isListLoading,
          fetchErrors = _this$props.fetchErrors,
          ListLoadingView = _this$props.ListLoadingView,
          ListErrorView = _this$props.ListErrorView,
          s = _this$props.styles;
      var listErrorElement = React.createElement("div", _extends({}, s('listContainer'), {
        key: "listError"
      }), React.createElement("div", s('inner'), React.createElement(ListErrorView, {
        errors: fetchErrors
      })));
      var listLoadingElement = React.createElement("div", _extends({}, s('listContainer'), {
        key: "listLoading"
      }), React.createElement("div", s('inner'), React.createElement(ListLoadingView, null)));

      if (fetchErrors && fetchErrors.length) {
        return listErrorElement;
      }

      if (isListLoading) {
        return listLoadingElement;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isListLoading = _this$props2.isListLoading,
          fetchErrors = _this$props2.fetchErrors,
          ListLoadingView = _this$props2.ListLoadingView,
          ListErrorView = _this$props2.ListErrorView,
          s = _this$props2.styles,
          rest = _objectWithoutProperties(_this$props2, ["isListLoading", "fetchErrors", "ListLoadingView", "ListErrorView", "styles"]);

      return React.createElement(RenderLoading, _extends({}, rest, {
        ContentAfter: this.getListLoadingOrError()
      }));
    }
  }]);

  return RenderLoadingList;
}(React.PureComponent), _defineProperty(_class2, "displayName", 'RenderLoadingList'), _defineProperty(_class2, "propTypes", {
  isListLoading: PropTypes.bool,
  fetchErrors: PropTypes.array,
  ListLoadingView: PropTypes.func,
  ListErrorView: PropTypes.func
}), _defineProperty(_class2, "defaultProps", {
  ListLoadingView: function ListLoadingView() {
    return React.createElement("div", null, "List loading");
  },
  ListErrorView: function ListErrorView(_ref) {
    var errors = _ref.errors;
    return React.createElement("div", null, _mapInstanceProperty(errors).call(errors, function (message, i) {
      return React.createElement("span", {
        key: i
      }, message);
    }));
  }
}), _temp)) || _class) || _class);
export default RenderLoadingList;